import packageJson from '../../package.json'

let baseUrl = "https://web-api.autoipacket.com/"

if(window.location.hostname !== 'document-viewer.autoipacket.com' && window.location.hostname !== 'www.document-viewer.autoipacket.com' && window.location.hostname !== 'document-viewer2.autoipacket.com' && window.location.hostname !== 'www.document-viewer2.autoipacket.com'){
  baseUrl = "https://web-api.staging-ipacket.us/"
}

if (window.ENV && window.ENV.API_URL) {
  baseUrl = window.ENV.API_URL.endsWith('/') ? window.ENV.API_URL : window.ENV.API_URL + '/';
} else if (process.env.API_URL) {
  baseUrl = process.env.API_URL.endsWith('/') ? process.env.API_URL : process.env.API_URL + '/';
}

if(window.location.hostname.includes('market-value-summary-revamp')){
  baseUrl = "https://market-value-summary-revamp.djapi.dev-ipacket.us/"
}


const AIP_DJAPI_URLS = {
  BASE_URL: baseUrl,
  STICKER_INFO: `${baseUrl}v2/sticker-puller/context`,
  STICKER_PRINT: `${baseUrl}v2/sticker-puller/download`,
  APPRAISAL_INFO: `${baseUrl}v3/appraisals/value-module`,
  MAKE_LIST: `${baseUrl}v1/make-list/`,
  MODEL_LIST: `${baseUrl}v1/model-list/`,
  VEHICLE_INQUIRY: `${baseUrl}v1/users/vehicle-inquire/`
}

//TODO Update Application Type Value
const AIP_DJAPI_HEADERS ={
  'AIP-Application-Type': 4,
  'AIP-Application-Version': packageJson.version
}

export default function AIP_DJAPI(url,params){
  if(params){
    if(params.headers){
      params.headers ={
        ...AIP_DJAPI_HEADERS,
        ...params.headers,
      }
    }
    else{
      params.headers ={
        ...AIP_DJAPI_HEADERS,
      }
    }
  }
  else{
    params = {
      headers:AIP_DJAPI_HEADERS
    }
  }

  return fetch(url,params).then((response)=>{
    return response
  })
}

export {AIP_DJAPI_URLS,AIP_DJAPI_HEADERS}
